import styled from 'styled-components'
import { fontType, toRem, mediaQuery } from '../../styles/functions';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #F3F3F3;
  padding: 25px;
  border-radius: 10px;   
  max-width: 406px;   
  width: 100%;
  ${mediaQuery('xxxs')(`	
  max-width: 100%;   
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`)}
`;

export const Slug = styled.h2`
	${fontType(2)};
	font-size: ${toRem(58)};
	font-weight: semibold;
	text-align: center;
	letter-spacing: -0.38px;
	color: ${({ theme }) => theme.COLORS.WHITE};
	max-width: 600px;
	margin-bottom: 48px;

	${mediaQuery('xxs')(`	
		font-size: ${toRem(48)};
	`)}
`

export const Title = styled.h1`
  font-weight: bold;
  text-align: center;
  ${mediaQuery('xxs')(`	
   font-size: ${toRem(22)};
 `)}
`;

export const Subtitle = styled.h2`
  font-weight: normal;
  text-align: center;
  ${mediaQuery('xxs')(`	
  font-size: ${toRem(22)};
`)}
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  //padding: 30px 0 10px 0;
  //min-width: 366px;
  width: 100%;

  ${mediaQuery('xxs')(`	
   //min-width: 0;
   padding-top: 15px;
	`)}
`;

export const ErrorMessage = styled.p`
  //position: absolute;
  //top: -22px;
  font-size: ${toRem(11)};
  color: ${(props) => props.theme.COLORS.ORANGE_ERROR};
  text-transform: uppercase;
  ${fontType(2)};
  word-wrap: break-word;
  line-height: 1.2;
`

export const Input = styled.input`
  background: #D9D9D9;
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  font-size: 18px;
  //max-width: 406px;
  width: 100%;
  ::placeholder{
    color: #999;
  }
`;


export const InputMasked = styled(InputMask)`
  background: #D9D9D9;
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  font-size: 18px;
  //max-width: 406px;
  width: 100%;
  ::placeholder{
    color: #999;
  }
`;


export const InputBirthdate = styled(DatePicker)`
  background: #D9D9D9;
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  font-size: 18px;
  //max-width: 406px;
  width: 100%;
  ::placeholder{
    color: #999;
  }
`;

export const InputPass = styled.input`
  background: #D9D9D9;
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  font-size: 18px;
  //max-width: 406px;
  width: 100%;
  ::placeholder{
    color: #24A4C4;
  }
`;

export const Button = styled.button`
  background: black;
  color: white;
  width: 366px;
  height: 57px;
  border-radius: 8px;
  margin-top: 10px;
  font-size: 18px;
  border: 0;
`;

export const DisabledInput = styled.input`
background: #D9D9D9;
  margin: 5px 0;
  padding: 10px;
  border-radius: 8px;
  border: 0;
  font-size: 18px;
  color: #CCC;
  cursor: not-allowed;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  //margin-bottom: 15px;
`;

export const Label = styled.label`
  display: block;
  font-weight: 400;
  margin: 0 0 -5px 3px;
  color: #868686;
`;